"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6102],{

/***/ 34557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82222);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89659);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);












var NextComposed = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var as = props.as, href = props.href, replace = props.replace, scroll = props.scroll, passHref = props.passHref, shallow = props.shallow, prefetch = props.prefetch, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "as",
        "href",
        "replace",
        "scroll",
        "passHref",
        "shallow",
        "prefetch"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: prefetch,
        as: as,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: passHref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    });
});
NextComposed.displayName = "NextComposed";
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        inherit: {
            color: "inherit",
            "&:hover": {
                color: "inherit",
                textDecoration: "none !important"
            }
        }
    };
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
var Link = function(props) {
    var _colorInherit = props.colorInherit, colorInherit = _colorInherit === void 0 ? false : _colorInherit, _renderATag = props.renderATag, renderATag = _renderATag === void 0 ? false : _renderATag, _activeClassName = props.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, classNameProps = props.className, innerRef = props.innerRef, naked = props.naked, href = props.href, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "colorInherit",
        "renderATag",
        "activeClassName",
        "className",
        "innerRef",
        "naked",
        "href"
    ]);
    var classes = useStyles();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pathname = typeof href === "string" ? href : href.pathname;
    var _obj;
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classNameProps, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.inherit, colorInherit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, activeClassName, router.pathname === pathname && activeClassName), _obj));
    if (renderATag) {
        if (typeof href !== "string") {
            console.error("Warning: Failed prop type: Invalid prop `href` of type `".concat(typeof href === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(href), "` supplied to") + "`components/Link` + renderATag: true, expected `string`");
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href,
            className: className,
            ref: innerRef
        }, other));
    }
    if (naked) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href,
            className: className,
            ref: innerRef
        }, other));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        component: NextComposed,
        className: className,
        ref: innerRef,
        href: href
    }, other));
};
var LinkWithRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Link, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        innerRef: ref
    }));
});
LinkWithRef.displayName = "LinkWithRef";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(LinkWithRef));


/***/ }),

/***/ 42783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ IS_SERVER; }
/* harmony export */ });
var IS_SERVER = "object" === "undefined";


/***/ }),

/***/ 93293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.$G; },
/* harmony export */   "$R": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.$R; },
/* harmony export */   "B1": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.B1; },
/* harmony export */   "DN": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.DN; },
/* harmony export */   "EN": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.EN; },
/* harmony export */   "FC": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.FC; },
/* harmony export */   "Op": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.Op; },
/* harmony export */   "P3": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.P3; },
/* harmony export */   "YR": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.YR; },
/* harmony export */   "aG": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.aG; },
/* harmony export */   "ai": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.ai; },
/* harmony export */   "b7": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.b7; },
/* harmony export */   "cK": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.cK; },
/* harmony export */   "cO": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.cO; },
/* harmony export */   "g2": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.g2; },
/* harmony export */   "iP": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.iP; },
/* harmony export */   "mR": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.mR; },
/* harmony export */   "nU": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.nU; },
/* harmony export */   "ob": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.ob; },
/* harmony export */   "pb": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.pb; },
/* harmony export */   "un": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.un; },
/* harmony export */   "w8": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.w8; },
/* harmony export */   "wb": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.wb; },
/* harmony export */   "x6": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.x6; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55208);



/***/ }),

/***/ 55208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ getCloseTagOf; },
/* harmony export */   "$R": function() { return /* binding */ formatDateYYYY_MM_DD; },
/* harmony export */   "B1": function() { return /* binding */ bfs; },
/* harmony export */   "DN": function() { return /* binding */ useFallbackImageInSSR; },
/* harmony export */   "EN": function() { return /* binding */ getStickyComponent; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "FC": function() { return /* binding */ jobTypeToString; },
/* harmony export */   "O9": function() { return /* binding */ birthdayValidation; },
/* harmony export */   "Op": function() { return /* binding */ getPeriodDate; },
/* harmony export */   "P3": function() { return /* binding */ getIsChannelUser; },
/* harmony export */   "YR": function() { return /* binding */ isTag; },
/* harmony export */   "aG": function() { return /* binding */ getRecruitScale; },
/* harmony export */   "ai": function() { return /* binding */ formatNumberComma; },
/* harmony export */   "b7": function() { return /* binding */ copySourceToClipboard; },
/* harmony export */   "c6": function() { return /* binding */ parseValues; },
/* harmony export */   "cK": function() { return /* binding */ getMobileSkickyHeights; },
/* harmony export */   "cO": function() { return /* binding */ formatBirthday; },
/* harmony export */   "fW": function() { return /* binding */ filterEmptyField; },
/* harmony export */   "g2": function() { return /* binding */ filterArrayEmpty; },
/* harmony export */   "iP": function() { return /* binding */ getComponentVisible; },
/* harmony export */   "mR": function() { return /* binding */ getSelectionText; },
/* harmony export */   "nU": function() { return /* binding */ getCurrentTab; },
/* harmony export */   "ob": function() { return /* binding */ getJobType; },
/* harmony export */   "pb": function() { return /* binding */ getValueFromActivityType; },
/* harmony export */   "un": function() { return /* binding */ formatPhoneNumber; },
/* harmony export */   "w8": function() { return /* binding */ formatDateYY_MM_DD; },
/* harmony export */   "wb": function() { return /* binding */ isValidTag; },
/* harmony export */   "x6": function() { return /* binding */ numberWithCommas; }
/* harmony export */ });
/* unused harmony export formatPeriodDate */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var date_fns_isValid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12274);
/* harmony import */ var date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23855);
/* harmony import */ var date_fns_subYears__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6758);
/* harmony import */ var lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29893);
/* harmony import */ var lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51584);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81763);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_overSome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87532);
/* harmony import */ var lodash_overSome__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_overSome__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16310);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47079);
/* harmony import */ var app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29012);
/* harmony import */ var constants_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42783);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35460);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15125);

















var formatPeriodDate = function(date) {
    if (!date) {
        return "";
    }
    var formattedDate = new Date(date);
    var yy = formattedDate.getFullYear() % 100;
    var mm = formattedDate.getMonth() + 1;
    var dd = formattedDate.getDate();
    return "".concat(yy, ".").concat(mm, ".").concat(dd);
};
var getPeriodDate = function(startAt, endAt) {
    if (!startAt && !endAt) {
        return "기간 없음";
    }
    return "".concat(formatPeriodDate(startAt), " ~ ").concat(formatPeriodDate(endAt));
};
var formatDateYY_MM_DD = function(date) {
    if (!date) {
        return "";
    }
    var formattedDate = new Date(date);
    var yy = formattedDate.getFullYear();
    var mm = formattedDate.getMonth() + 1;
    var dd = formattedDate.getDate();
    return "".concat(yy, ".").concat(mm, ".").concat(dd);
};
var formatDateYYYY_MM_DD = function(date) {
    if (!date) {
        return "";
    }
    var formattedDate = new Date(date);
    return formattedDate.toISOString().split("T")[0];
};
function useFallbackImageInSSR(fallbackSrc) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    /**
   * Error happened / catched after hydration
   */ var onError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.target.src = fallbackSrc;
    }, [
        fallbackSrc
    ]);
    /**
   * Error happened before hydration, but catched after hydration
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (ref && ref.current) {
            var _current = ref.current, complete = _current.complete, naturalHeight = _current.naturalHeight;
            var errorLoadingImgBeforeHydration = complete && naturalHeight === 0;
            if (errorLoadingImgBeforeHydration) {
                ref.current.src = fallbackSrc;
            }
        }
    }, [
        fallbackSrc
    ]);
    return {
        ref: ref,
        onError: onError
    };
}
var shortenText = function(text, length) {
    if (text.length > length) {
        return "".concat(text.substr(0, length), "...");
    }
    return text;
};
var jobTypeToString = function(jobType) {
    switch(jobType){
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.NEW */ .O4l.NEW:
            {
                return "신입";
            }
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.INTERN */ .O4l.INTERN:
            {
                return "인턴";
            }
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED:
            {
                return "경력직";
            }
        case generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.CONTRACT */ .O4l.CONTRACT:
            {
                return "계약직";
            }
        default:
            {
                throw new Error("job type is not valid.");
            }
    }
};
var getJobType = function(jobTypes) {
    var jobs = jobTypes.map(function(jobType) {
        return jobTypeToString(jobType);
    });
    return jobs === null || jobs === void 0 ? void 0 : jobs.join(", ");
};
var getRecruitScale = function(recruitScale) {
    switch(recruitScale){
        case undefined:
        case null:
        case constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .RecruitScaleType.ONE_DIGIT */ .aP.ONE_DIGIT:
            {
                return "0명";
            }
        case constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .RecruitScaleType.TEN_DIGIT */ .aP.TEN_DIGIT:
            {
                return "00명";
            }
        case constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .RecruitScaleType.HUNDRED_DIGIT */ .aP.HUNDRED_DIGIT:
            {
                return "000명";
            }
        default:
            {
                return "".concat(recruitScale, "명");
            }
    }
};
var getValueFromActivityType = function(activityTypeID, values) {
    var _obj;
    var navigate = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, values.activity), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, values.contest), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CLUB */ .kF.CLUB, values.club), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.INTERN */ .kF.INTERN, values.intern), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, values.recruit), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, values.education), _obj);
    if (!activityTypeID) {
        throw new Error("Activity type is not valid.");
    }
    return navigate[activityTypeID];
};
var formatPhoneNumber = function(phoneNumber) {
    var matched = phoneNumber.match(/^(010)(\d{4})(\d{4})$/);
    if (matched) {
        return matched[1] + "-" + matched[2] + "-" + matched[3];
    }
};
var filterEmpty = function(value) {
    if (!lodash_isNumber__WEBPACK_IMPORTED_MODULE_5___default()(value) && !lodash_isBoolean__WEBPACK_IMPORTED_MODULE_2___default()(value)) {
        return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(value);
    }
    return false;
};
var filterEmptyField = lodash_fp_omitBy__WEBPACK_IMPORTED_MODULE_1___default()(lodash_overSome__WEBPACK_IMPORTED_MODULE_6___default()([
    (lodash_isNil__WEBPACK_IMPORTED_MODULE_4___default()),
    filterEmpty
]));
var filterArrayEmpty = function(arr) {
    var filterArray = lodash_overSome__WEBPACK_IMPORTED_MODULE_6___default()([
        (lodash_isNil__WEBPACK_IMPORTED_MODULE_4___default()),
        filterEmpty
    ]);
    var filteredArray = arr.filter(function(it) {
        return !filterArray(it);
    });
    return filteredArray;
};
// https://github.com/sindresorhus/query-string/blob/7712622f5ae8cc1f99ae45f4af1a1965efec44ac/index.js
var parseValues = function(values, options) {
    if (!options) return values;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            var value = values[k];
            if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") {
                value = Number(value);
            } else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
                value = value.toLowerCase() === "true";
            }
            values[k] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return values;
};
var bfs = function(root, childProp, visit, depth) {
    var q = [];
    var node;
    var currDepth = 0;
    q.push(root);
    q.push(null);
    while(q.length !== 0){
        node = q.shift();
        if (!node) {
            currDepth += 1;
            q.push(null);
            if (!q[0]) break;
            continue;
        }
        if (depth !== 0 && !depth) {
            visit(node);
        } else {
            currDepth === depth && visit(node);
        }
        var children = node[childProp];
        for(var i = 0; i < (children === null || children === void 0 ? void 0 : children.length); i += 1){
            q.push(children[i]);
        }
    }
};
var copySourceToClipboard = function(event) {
    var ref;
    event.stopPropagation();
    event.preventDefault();
    var span = document.createElement("SPAN");
    var content = (ref = window.getSelection()) === null || ref === void 0 ? void 0 : ref.getRangeAt(0).cloneContents();
    if (content) {
        span.appendChild(content);
        event.clipboardData.setData("Text", span.textContent + "\n\n" + _config__WEBPACK_IMPORTED_MODULE_11__/* .COPY_SUFFIX */ .jk) // ie
        ;
        event.clipboardData.setData("text/html", span.innerHTML + "<br /><br />" + _config__WEBPACK_IMPORTED_MODULE_11__/* .COPY_SUFFIX */ .jk);
        event.clipboardData.setData("text/plain", span.textContent + "\n\n" + _config__WEBPACK_IMPORTED_MODULE_11__/* .COPY_SUFFIX */ .jk);
    }
};
function numberWithCommas(count) {
    return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
var NATIVE_TAGS = [
    "address",
    "article",
    "aside",
    "blockquote",
    "details",
    "dialog",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "li",
    "main",
    "nav",
    "ol",
    "p",
    "pre",
    "section",
    "table",
    "ul",
    "a",
    "abbr",
    "acronym",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "br",
    "button",
    "canvas",
    "cite",
    "code",
    "data",
    "datalist",
    "del",
    "dfn",
    "em",
    "embed",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "map",
    "mark",
    "meter",
    "noscript",
    "object",
    "output",
    "picture",
    "progress",
    "q",
    "ruby",
    "s",
    "samp",
    "script",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "svg",
    "template",
    "textarea",
    "time",
    "u",
    "tt",
    "var",
    "video",
    "wbr", 
];
function isValidTag(tagName) {
    return NATIVE_TAGS.includes(tagName);
}
function isTag(tag) {
    return /(<([^>]+)>)/gi.test(tag);
}
function getCloseTagOf(tag) {
    if (tag.charAt(1) === "/") {
        return tag;
    }
    return "".concat(tag.substring(0, 1), "/").concat(tag.substring(1, tag.length));
}
function getSelectionText() {
    if (constants_common__WEBPACK_IMPORTED_MODULE_13__/* .IS_SERVER */ .W) {
        return "";
    }
    var selection = window.getSelection();
    if (!selection) {
        return "";
    }
    return selection === null || selection === void 0 ? void 0 : selection.toString();
}
var formatBirthday = function(birthday) {
    // 숫자만 추출하고 8자리로 제한
    var originNumber = birthday.replace(/[^0-9]/g, "").slice(0, 8);
    if (originNumber.length <= 4) {
        return originNumber;
    }
    if (originNumber.length <= 6) {
        return originNumber.replace(/(\d{4})(\d{1,2})/, "$1-$2");
    }
    return originNumber.replace(/(\d{4})(\d{2})(\d{0,2})/, "$1-$2-$3");
};
/**
 * 생년월일 validation을 위한 yup schema 생성 함수
 * @param format - 날짜 형식 ('YYYY-MM-DD' | 'YYYYMMDD')
 * @returns yup string schema
 */ var birthdayValidation = function(format) {
    var config = {
        "YYYY-MM-DD": {
            pattern: /^[0-9-]+$/,
            length: 10,
            getLengthToCheck: function(birthday) {
                return birthday.length;
            }
        },
        YYYYMMDD: {
            pattern: /^[0-9.]+$/,
            length: 8,
            getLengthToCheck: function(birthday) {
                return birthday.replace(/[^0-9]/g, "").length;
            }
        }
    };
    var _format = config[format], pattern = _format.pattern, length = _format.length, getLengthToCheck = _format.getLengthToCheck;
    return yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().test({
        name: "is-only-number",
        test: function(birthday) {
            var result = !birthday || pattern.test(birthday);
            return result;
        },
        message: "생년월일 형식이 올바르지 않습니다"
    }).test({
        name: "is-valid-date",
        test: function(birthday) {
            if (!birthday) {
                return true;
            }
            var birthdayISO = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(birthday);
            var lengthToCheck = getLengthToCheck(birthday);
            var isValidated = lengthToCheck === length && (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(birthdayISO);
            var minimumYear = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("1900-01-01");
            var isAfter1900 = birthdayISO >= minimumYear;
            var isFuture = birthdayISO > new Date();
            return isValidated && isAfter1900 && !isFuture;
        },
        message: "생년월일 형식이 올바르지 않습니다"
    }).test({
        name: "is-over-15",
        test: function(birthday) {
            if (!birthday) {
                return true;
            }
            var birthdayISO = (0,date_fns_parseISO__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(birthday);
            var minimumDate = (0,date_fns_subYears__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(new Date(), 15);
            var isValidDate = (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(birthdayISO);
            var result = isValidDate && birthdayISO <= minimumDate;
            return result;
        },
        message: "만 15세 미만은 이용할 수 없습니다"
    }).required("생년월일을 입력해주세요");
};
var formatNumberComma = function(count) {
    return new Intl.NumberFormat("ko-KR").format(count);
};
var getMobileSkickyHeights = function(mobileStickyComponents) {
    var mobileHeightList = [
        {
            component: "Header",
            height: 50
        },
        {
            component: "MobileSearchBar",
            height: 60
        },
        {
            component: "MobileNavTab",
            height: 50
        }, 
    ];
    var heightMap = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mobileStickyComponents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var targetComponent = _step.value;
            var height = 0;
            for(var index = 0; index < mobileHeightList.length && mobileHeightList[index].component !== targetComponent; index++){
                var _index = mobileHeightList[index], component = _index.component, componentHeight = _index.height;
                if (mobileStickyComponents.includes(component)) {
                    height += componentHeight;
                }
            }
            heightMap[targetComponent] = height;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return heightMap;
};
var getComponentVisible = function(renderComponents) {
    var componentVisible = {
        ExternalNavBar: false,
        Header: false,
        SearchBar: false,
        InternalNavBar: false,
        MobileSearchBar: false,
        MobileNavTab: false,
        Footer: false
    };
    renderComponents.forEach(function(component) {
        componentVisible[component] = true;
    });
    return componentVisible;
};
var getStickyComponent = function(mobileStickyComponents) {
    var isStickyComponent = {
        Header: false,
        MobileSearchBar: false,
        MobileNavTab: false
    };
    mobileStickyComponents.forEach(function(component) {
        isStickyComponent[component] = true;
    });
    return isStickyComponent;
};
var getCurrentTab = function(pathname, query, activity) {
    if (pathname === "/") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ROOT */ .Ld.ROOT;
    if (pathname.match(/^\/channel.*/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CHANNEL */ .Ld.CHANNEL;
    if (pathname.match(/^\/calendar.*/)) {
        if (query.parentActiveTab === "activity") {
            return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CALENDAR_ACTIVITY */ .Ld.CALENDAR_ACTIVITY;
        }
        return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CALENDAR_RECRUIT */ .Ld.CALENDAR_RECRUIT;
    }
    if (pathname.match(/^\/cover-letter.*/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.COVER_LETTER */ .Ld.COVER_LETTER;
    if (pathname.match(/^\/self-introduction.*/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.SELF_INTRODUCTION */ .Ld.SELF_INTRODUCTION;
    if (pathname === "/list/intern") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.INTERN */ .Ld.INTERN;
    if (pathname === "/list/recruit") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.RECRUIT */ .Ld.RECRUIT;
    if (pathname === "/list/activity") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ACTIVITY */ .Ld.ACTIVITY;
    if (pathname === "/list/contest") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CONTEST */ .Ld.CONTEST;
    if (pathname === "/list/club") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CLUB */ .Ld.CLUB;
    if (pathname === "/list/education") return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.EDUCATION */ .Ld.EDUCATION;
    if (pathname.match(/^\/team($|\/)/)) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.TEAM_RECRUIT */ .Ld.TEAM_RECRUIT;
    if (pathname.match(/^\/activity.*/)) {
        var ref;
        var isIntern = activity === null || activity === void 0 ? void 0 : (ref = activity.jobTypes) === null || ref === void 0 ? void 0 : ref.includes(generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .JobType.INTERN */ .O4l.INTERN);
        if (isIntern && (activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.INTERN */ .Ld.INTERN;
        if (!isIntern && (activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.RECRUIT */ .Ld.RECRUIT;
        if ((activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ACTIVITY */ .Ld.ACTIVITY;
        if ((activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CONTEST */ .kF.CONTEST) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CONTEST */ .Ld.CONTEST;
        if ((activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_10__/* .ActivityTypeID.CLUB */ .kF.CLUB) return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.CLUB */ .Ld.CLUB;
    }
    return app_layout_constant_pageLayout_type__WEBPACK_IMPORTED_MODULE_9__/* .NavBarActiveKey.ROOT */ .Ld.ROOT;
};
var getIsChannelUser = function(currentUser) {
    return currentUser && currentUser.type !== generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .UserType.NORMAL */ .FWD.NORMAL;
};


/***/ })

}]);